{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Aplicaciones",
    "back": "Volver",
    "campaigns": "Campañas",
    "dashboard": "Cuadro de mando",
    "devices": "Estación local S4",
    "dtwins": {
      "label": "Equipos",
      "manage": {
        "fleets": "Flotas",
        "label": "Gestionar",
        "devices": "Equipos"
      },
      "overview": {
        "label": "Descripción",
        "map": "Mapa"
      }
    },
    "logout": "Desconexión",
    "logs": "Cuaderno de bitácora",
    "overview": "Resumen",
    "parameters": {
      "label": "Configuración",
      "platformMgt": "Gestión de la plataforma",
      "features": {
        "applicationManagement": "Gestión de las aplicaciones",
        "firmwareManagement": "Gestión de los firmwares",
        "deviceConfiguration": "Configuración de los equipos",
        "label": "Funcionalidades",
        "licenseManagement": "Gestión de la licencia"
      },
      "monitoring": {
        "label": "Monitorización",
        "settings": "Configuraciones"
      }
    },
    "product": "Producto",
    "sector": {
      "label": "Red",
      "placeholder": "Seleccionar una red"
    },
    "sectors": "Sectores",
    "settings": "Configuraciones",
    "users": "Usuarios"
  },
  "header": {
    "sectors": "Sectores",
    "userMenu": {
      "title": "Menú de la cuenta",
      "logout": "Desconexión",
      "userAccount": "Cuenta de usuario",
      "about": "Acerca de",
      "connectMyMobileApp": "Conectar mi aplicación móvil"
    },
    "admin": "Administración"
  }
}
